import React from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import Tabs from '../../../components/Tabs';
import Title from '../../../components/Title';
import PublisherIdfaRequestConfig from './PublisherIdfaRequestConfig';
import PublisherLocationRequestConfig from './PublisherLocationRequestConfig';

const SdkConfiguration = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const { publisherId } = useParams();

  return ( <>
    <Title main={"SDK"} sub={t("publisher.actions.configuration")} onBack={()=>(history.push(`/publishers/${publisherId}`))}/>
    <Tabs active={"locationRequestConfig"}>
      <PublisherLocationRequestConfig icon={"configure"} as="locationRequestConfig"/>
      <PublisherIdfaRequestConfig icon={"configure"} as="idfaRequestConfig"/>
    </Tabs>
  </> );
}
 
export default SdkConfiguration;